import React from 'react';
import {PageViewHeader} from 'components-lib';

export const GoogleSitesHeader = () => {
  return (
    <PageViewHeader
      fullFlexWidth
      withColumnPadding={false}
      heading="Google Sites"
      headingColor="textPrimary"
      withBackButton={false}
    />
  );
};
